/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const protectionSettingsDefaultsBookingCapCountMin = -9007199254740991
export const protectionSettingsDefaultsBookingCapCountMax = 9007199254740991

export const protectionSettingsDefaultsBookingCapDaysMin = -9007199254740991
export const protectionSettingsDefaultsBookingCapDaysMax = 9007199254740991

export const protectionSettingsDefaultsChallengePointsMin = -9007199254740991
export const protectionSettingsDefaultsChallengePointsMax = 9007199254740991

export const protectionSettingsDefaultsDailyAssessmentCeilingMin = -9007199254740991
export const protectionSettingsDefaultsDailyAssessmentCeilingMax = 9007199254740991

export const protectionSettingsDefaultsFillTimeMinMsMin = -9007199254740991
export const protectionSettingsDefaultsFillTimeMinMsMax = 9007199254740991

export const protectionSettingsDefaultsLimitsBlockSecMin = -9007199254740991
export const protectionSettingsDefaultsLimitsBlockSecMax = 9007199254740991

export const protectionSettingsDefaultsLimitsHardMin = -9007199254740991
export const protectionSettingsDefaultsLimitsHardMax = 9007199254740991

export const protectionSettingsDefaultsLimitsSoftMin = -9007199254740991
export const protectionSettingsDefaultsLimitsSoftMax = 9007199254740991

export const protectionSettingsDefaultsLimitsWindowSecMin = -9007199254740991
export const protectionSettingsDefaultsLimitsWindowSecMax = 9007199254740991

export const protectionSettingsDefaultsScorePoints01Min = -9007199254740991
export const protectionSettingsDefaultsScorePoints01Max = 9007199254740991

export const protectionSettingsDefaultsScorePoints03Min = -9007199254740991
export const protectionSettingsDefaultsScorePoints03Max = 9007199254740991

export const protectionSettingsEffectiveBookingCapCountMin = -9007199254740991
export const protectionSettingsEffectiveBookingCapCountMax = 9007199254740991

export const protectionSettingsEffectiveBookingCapDaysMin = -9007199254740991
export const protectionSettingsEffectiveBookingCapDaysMax = 9007199254740991

export const protectionSettingsEffectiveChallengePointsMin = -9007199254740991
export const protectionSettingsEffectiveChallengePointsMax = 9007199254740991

export const protectionSettingsEffectiveDailyAssessmentCeilingMin = -9007199254740991
export const protectionSettingsEffectiveDailyAssessmentCeilingMax = 9007199254740991

export const protectionSettingsEffectiveFillTimeMinMsMin = -9007199254740991
export const protectionSettingsEffectiveFillTimeMinMsMax = 9007199254740991

export const protectionSettingsEffectiveLimitsBlockSecMin = -9007199254740991
export const protectionSettingsEffectiveLimitsBlockSecMax = 9007199254740991

export const protectionSettingsEffectiveLimitsHardMin = -9007199254740991
export const protectionSettingsEffectiveLimitsHardMax = 9007199254740991

export const protectionSettingsEffectiveLimitsSoftMin = -9007199254740991
export const protectionSettingsEffectiveLimitsSoftMax = 9007199254740991

export const protectionSettingsEffectiveLimitsWindowSecMin = -9007199254740991
export const protectionSettingsEffectiveLimitsWindowSecMax = 9007199254740991

export const protectionSettingsEffectiveScorePoints01Min = -9007199254740991
export const protectionSettingsEffectiveScorePoints01Max = 9007199254740991

export const protectionSettingsEffectiveScorePoints03Min = -9007199254740991
export const protectionSettingsEffectiveScorePoints03Max = 9007199254740991

export const protectionSettingsOverridesBookingCapCountMin = -9007199254740991
export const protectionSettingsOverridesBookingCapCountMax = 9007199254740991

export const protectionSettingsOverridesBookingCapDaysMin = -9007199254740991
export const protectionSettingsOverridesBookingCapDaysMax = 9007199254740991

export const protectionSettingsOverridesChallengePointsMin = -9007199254740991
export const protectionSettingsOverridesChallengePointsMax = 9007199254740991

export const protectionSettingsOverridesDailyAssessmentCeilingMin = -9007199254740991
export const protectionSettingsOverridesDailyAssessmentCeilingMax = 9007199254740991

export const protectionSettingsOverridesFillTimeMinMsMin = -9007199254740991
export const protectionSettingsOverridesFillTimeMinMsMax = 9007199254740991

export const protectionSettingsOverridesLimitsBlockSecMin = -9007199254740991
export const protectionSettingsOverridesLimitsBlockSecMax = 9007199254740991

export const protectionSettingsOverridesLimitsHardMin = -9007199254740991
export const protectionSettingsOverridesLimitsHardMax = 9007199254740991

export const protectionSettingsOverridesLimitsSoftMin = -9007199254740991
export const protectionSettingsOverridesLimitsSoftMax = 9007199254740991

export const protectionSettingsOverridesLimitsWindowSecMin = -9007199254740991
export const protectionSettingsOverridesLimitsWindowSecMax = 9007199254740991

export const protectionSettingsOverridesScorePoints01Min = -9007199254740991
export const protectionSettingsOverridesScorePoints01Max = 9007199254740991

export const protectionSettingsOverridesScorePoints03Min = -9007199254740991
export const protectionSettingsOverridesScorePoints03Max = 9007199254740991

export const protectionSettingsUpdatedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const protectionSettingsUpdatedByOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)

export const ProtectionSettings = zod.object({
  defaults: zod.object({
    allowedEmbedOrigins: zod.array(zod.string()),
    bookingCap: zod.object({
      count: zod
        .int()
        .min(protectionSettingsDefaultsBookingCapCountMin)
        .max(protectionSettingsDefaultsBookingCapCountMax),
      days: zod.int().min(protectionSettingsDefaultsBookingCapDaysMin).max(protectionSettingsDefaultsBookingCapDaysMax),
    }),
    challengePoints: zod
      .int()
      .min(protectionSettingsDefaultsChallengePointsMin)
      .max(protectionSettingsDefaultsChallengePointsMax),
    counterChallengeMode: zod.enum(['monitor', 'enforce']),
    dailyAssessmentCeiling: zod
      .int()
      .min(protectionSettingsDefaultsDailyAssessmentCeilingMin)
      .max(protectionSettingsDefaultsDailyAssessmentCeilingMax),
    fillTimeMinMs: zod
      .int()
      .min(protectionSettingsDefaultsFillTimeMinMsMin)
      .max(protectionSettingsDefaultsFillTimeMinMsMax),
    limits: zod.record(
      zod.string(),
      zod.object({
        blockSec: zod
          .int()
          .min(protectionSettingsDefaultsLimitsBlockSecMin)
          .max(protectionSettingsDefaultsLimitsBlockSecMax)
          .optional(),
        hard: zod
          .int()
          .min(protectionSettingsDefaultsLimitsHardMin)
          .max(protectionSettingsDefaultsLimitsHardMax)
          .optional(),
        soft: zod
          .int()
          .min(protectionSettingsDefaultsLimitsSoftMin)
          .max(protectionSettingsDefaultsLimitsSoftMax)
          .optional(),
        windowSec: zod
          .int()
          .min(protectionSettingsDefaultsLimitsWindowSecMin)
          .max(protectionSettingsDefaultsLimitsWindowSecMax)
          .optional(),
      }),
    ),
    ruleOverrides: zod.record(zod.string(), zod.literal('monitor')),
    scoreChallengeMode: zod.enum(['monitor', 'enforce']),
    scorePoints: zod.object({
      '0.1': zod.int().min(protectionSettingsDefaultsScorePoints01Min).max(protectionSettingsDefaultsScorePoints01Max),
      '0.3': zod.int().min(protectionSettingsDefaultsScorePoints03Min).max(protectionSettingsDefaultsScorePoints03Max),
    }),
  }),
  effective: zod.object({
    allowedEmbedOrigins: zod.array(zod.string()),
    bookingCap: zod.object({
      count: zod
        .int()
        .min(protectionSettingsEffectiveBookingCapCountMin)
        .max(protectionSettingsEffectiveBookingCapCountMax),
      days: zod
        .int()
        .min(protectionSettingsEffectiveBookingCapDaysMin)
        .max(protectionSettingsEffectiveBookingCapDaysMax),
    }),
    challengePoints: zod
      .int()
      .min(protectionSettingsEffectiveChallengePointsMin)
      .max(protectionSettingsEffectiveChallengePointsMax),
    counterChallengeMode: zod.enum(['monitor', 'enforce']),
    dailyAssessmentCeiling: zod
      .int()
      .min(protectionSettingsEffectiveDailyAssessmentCeilingMin)
      .max(protectionSettingsEffectiveDailyAssessmentCeilingMax),
    fillTimeMinMs: zod
      .int()
      .min(protectionSettingsEffectiveFillTimeMinMsMin)
      .max(protectionSettingsEffectiveFillTimeMinMsMax),
    limits: zod.record(
      zod.string(),
      zod.object({
        blockSec: zod
          .int()
          .min(protectionSettingsEffectiveLimitsBlockSecMin)
          .max(protectionSettingsEffectiveLimitsBlockSecMax)
          .optional(),
        hard: zod
          .int()
          .min(protectionSettingsEffectiveLimitsHardMin)
          .max(protectionSettingsEffectiveLimitsHardMax)
          .optional(),
        soft: zod
          .int()
          .min(protectionSettingsEffectiveLimitsSoftMin)
          .max(protectionSettingsEffectiveLimitsSoftMax)
          .optional(),
        windowSec: zod
          .int()
          .min(protectionSettingsEffectiveLimitsWindowSecMin)
          .max(protectionSettingsEffectiveLimitsWindowSecMax)
          .optional(),
      }),
    ),
    ruleOverrides: zod.record(zod.string(), zod.literal('monitor')),
    scoreChallengeMode: zod.enum(['monitor', 'enforce']),
    scorePoints: zod.object({
      '0.1': zod
        .int()
        .min(protectionSettingsEffectiveScorePoints01Min)
        .max(protectionSettingsEffectiveScorePoints01Max),
      '0.3': zod
        .int()
        .min(protectionSettingsEffectiveScorePoints03Min)
        .max(protectionSettingsEffectiveScorePoints03Max),
    }),
  }),
  overrides: zod.object({
    allowedEmbedOrigins: zod.array(zod.string()).optional(),
    bookingCap: zod
      .object({
        count: zod
          .int()
          .min(protectionSettingsOverridesBookingCapCountMin)
          .max(protectionSettingsOverridesBookingCapCountMax),
        days: zod
          .int()
          .min(protectionSettingsOverridesBookingCapDaysMin)
          .max(protectionSettingsOverridesBookingCapDaysMax),
      })
      .optional(),
    challengePoints: zod
      .int()
      .min(protectionSettingsOverridesChallengePointsMin)
      .max(protectionSettingsOverridesChallengePointsMax)
      .optional(),
    counterChallengeMode: zod.enum(['monitor', 'enforce']).optional(),
    dailyAssessmentCeiling: zod
      .int()
      .min(protectionSettingsOverridesDailyAssessmentCeilingMin)
      .max(protectionSettingsOverridesDailyAssessmentCeilingMax)
      .optional(),
    fillTimeMinMs: zod
      .int()
      .min(protectionSettingsOverridesFillTimeMinMsMin)
      .max(protectionSettingsOverridesFillTimeMinMsMax)
      .optional(),
    limits: zod
      .record(
        zod.string(),
        zod.object({
          blockSec: zod
            .int()
            .min(protectionSettingsOverridesLimitsBlockSecMin)
            .max(protectionSettingsOverridesLimitsBlockSecMax)
            .optional(),
          hard: zod
            .int()
            .min(protectionSettingsOverridesLimitsHardMin)
            .max(protectionSettingsOverridesLimitsHardMax)
            .optional(),
          soft: zod
            .int()
            .min(protectionSettingsOverridesLimitsSoftMin)
            .max(protectionSettingsOverridesLimitsSoftMax)
            .optional(),
          windowSec: zod
            .int()
            .min(protectionSettingsOverridesLimitsWindowSecMin)
            .max(protectionSettingsOverridesLimitsWindowSecMax)
            .optional(),
        }),
      )
      .optional(),
    ruleOverrides: zod.record(zod.string(), zod.literal('monitor')).optional(),
    scoreChallengeMode: zod.enum(['monitor', 'enforce']).optional(),
    scorePoints: zod
      .object({
        '0.1': zod
          .int()
          .min(protectionSettingsOverridesScorePoints01Min)
          .max(protectionSettingsOverridesScorePoints01Max),
        '0.3': zod
          .int()
          .min(protectionSettingsOverridesScorePoints03Min)
          .max(protectionSettingsOverridesScorePoints03Max),
      })
      .optional(),
  }),
  updatedAt: zod.union([zod.iso.datetime({ offset: true }).regex(protectionSettingsUpdatedAtOneRegExp), zod.null()]),
  updatedBy: zod.union([
    zod.object({
      name: zod.string(),
      userId: zod.uuid().regex(protectionSettingsUpdatedByOneUserIdRegExp),
    }),
    zod.null(),
  ]),
})

export type ProtectionSettings = zod.input<typeof ProtectionSettings>
export type ProtectionSettingsOutput = zod.output<typeof ProtectionSettings>
